import React, { useEffect, useState } from 'react'
import './VendingMachines.css'
import { DARKCOLORS, LIGHTCOLORS, ROUTES } from '../../../Utils/constants'
import { AddCircleOutline, FiberManualRecord } from '@mui/icons-material'
import { useThemeContext } from '../../../Context/ThemeContext'
import { useTranslation } from 'react-i18next'
import { styled, alpha } from '@mui/material/styles';
import SearchIcon from '@mui/icons-material/Search';
import { Box, IconButton, MenuItem, Select } from '@mui/material';
import InputBase from '@mui/material/InputBase';
import InternalMachine from './internalMachine'
import Franchisemachine from './franchisemachine'
import { useLocation, useNavigate } from 'react-router-dom'
import { DropDownIcon, Cardtoggle, Listtoggle } from '../../../Components/Layouts/CustomIcons'
import useAuth from '../../../Hooks/useAuth'

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  '&:hover': {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginRight: theme.spacing(2),
  marginLeft: 0,
  fontSize: '16px',
}));

const SearchIconWrapper = styled('div')(() => ({
  width: '20px',
  height: '20.001px',
  flexShrink: 0,
  opacity: 0.5,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '14px',
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  flexGrow: 1, // Allows the input to expand and fill the available space
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1),
    width: '100%',
    transition: theme.transitions.create('width'),
  },
  fontSize: '14px'
}));

const VendingMachines = () => {
  const navigate = useNavigate()
  const location = useLocation(); 
  const [activeTab, setActiveTab] = useState(0)
  const { t } = useTranslation();
  const { mode } = useThemeContext(); 
  const [franchiseId, setFranchiseId] = useState("");
  const { user } = useAuth();

  const [searchTerm, setSearchTerm] = useState("");
  const [viewMode, setViewMode] = useState('card');
  const [statusFilter, setStatusFilter] = useState("");
  const handleSearchChange = (e) => setSearchTerm(e.target.value);

  const handleStatusFilterChange = (e) => setStatusFilter(e.target.value);

  const borderColor1 = mode === 'dark' ? DARKCOLORS.GreyScale40 : LIGHTCOLORS.GreyScale40;
  const borderColor2 = mode === 'dark' ? DARKCOLORS.GreyScale30 : LIGHTCOLORS.GreyScale30;
  const blueColor = mode === 'dark' ? DARKCOLORS.Primary500 : LIGHTCOLORS.Primary500;
  const dropCircle = mode === 'dark' ? DARKCOLORS.GreyScale50 : LIGHTCOLORS.GreyScale50;
  const dropIcon = mode === 'dark' ? DARKCOLORS.GreyScale80 : LIGHTCOLORS.GreyScale80;
  const Bgmenu = mode === 'dark' ? DARKCOLORS.BackgroundMenu : LIGHTCOLORS.BackgroundMenu;
  const dropDownBg = mode === 'dark' ? DARKCOLORS.BackgroundCard : LIGHTCOLORS.BackgroundCard;
  const textColor = mode === 'dark' ? DARKCOLORS.HeadingLightBackground : LIGHTCOLORS.HeadingLightBackground;
  const toggleIconColor = mode === 'dark' ? DARKCOLORS.GreyScale40 : '#5A5A5A';
  const Toggelbutton = mode === 'dark' ? DARKCOLORS.BackgroundDashboard : LIGHTCOLORS.BackgroundDashboard;


  useEffect(() => {
    const state = location.state;
    // console.log(state);

    if (state && state.franchise) {
      if (state.franchise === 'franchise') {
        if (state.franchiseId) setFranchiseId(state.franchiseId)
        setActiveTab(1);  
      } else {
        setActiveTab(0);  
      }
    }
  }, [location.state]);  

  return (
    <div className='main-container'>
      <div className='row'>
        <div className='tabs'>
          {!user?.roles?.includes('ROLE_SUPER_ADMIN') && (
            <>
              <div style={{ position: 'relative' }}>
                <div onClick={() => setActiveTab(0)} className='page-heading' style={{ color: textColor }}>{t('vendingMachines.vendingMachines')}</div>
              </div>
            </>
          )}

          {user?.roles?.includes('ROLE_SUPER_ADMIN') && (
            <>
              <div style={{ position: 'relative' }}>
                <div onClick={() => setActiveTab(0)} className='page-heading' style={activeTab === 0 ? { color: blueColor } : { color: borderColor2 }}>{t('vendingMachines.internamMachines')}</div>
                {activeTab === 0 && <FiberManualRecord className='heading-dot' sx={{ color: blueColor, display: 'flex', justifySelf: 'center', fontSize: '10px', marginTop: "10px" }}>.</FiberManualRecord>}
              </div>

              <div style={{ position: 'relative' }}>
                <div onClick={() => setActiveTab(1)} className='page-heading' style={activeTab === 1 ? { color: blueColor } : { color: borderColor2 }}>{t('vendingMachines.FranchiseMachines')}</div>
                {activeTab === 1 && <FiberManualRecord className='heading-dot' sx={{ color: blueColor, display: 'flex', justifySelf: 'center', fontSize: '10px', marginTop: "10px" }}>.</FiberManualRecord>}
              </div>
            </>
          )}
          {/* demo data for internal machines */}
          
        </div>
        <div className='view-mode-toggle mobile_toggle'>
            {/* View Mode Toggle - Internal Machines Only */}
            {activeTab === 0 && (
              <Box sx={{ display: 'flex', alignItems: 'center', padding: '4px', gap: '4px', borderRadius: '999px !important', mr: 1, backgroundColor: Bgmenu }}>
                <Box
                  onClick={() => setViewMode('card')}
                  sx={{
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '999px !important',
                    cursor: 'pointer',
                    backgroundColor: viewMode === 'card'
                      ? Toggelbutton
                      : 'transparent',
                    transition: 'all 0.2s ease',

                  }}
                  title="Card view"
                >
                  <Listtoggle color={toggleIconColor} />
                </Box>
                <Box
                  onClick={() => setViewMode('table')}
                  sx={{
                    width: '32px',
                    height: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '999px',
                    cursor: 'pointer',
                    backgroundColor: viewMode === 'table'
                      ? Toggelbutton
                      : 'transparent',

                    transition: 'all 0.2s ease',

                  }}
                  title="Table view"
                >
                  <Cardtoggle fillColor={toggleIconColor} />
                </Box>
              </Box>
            )}
          </div>


      </div>
      <div className='toggle-row-sec' style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
      }} >
        <div className='view-mode-toggle website_toggle'>
          {/* View Mode Toggle - Internal Machines Only */}
          {activeTab === 0 && (
            <Box sx={{ display: 'flex', alignItems: 'center', padding: '4px', gap: '4px', borderRadius: '999px !important', mr: 1, backgroundColor: Bgmenu }}>
              <Box
                onClick={() => setViewMode('card')}
                sx={{
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '999px !important',
                  cursor: 'pointer',
                  backgroundColor: viewMode === 'card'
                    ? Toggelbutton
                    : 'transparent',
                  transition: 'all 0.2s ease',

                }}
                title="Card view"
              >
                <Listtoggle color={toggleIconColor} />
              </Box>
              <Box
                onClick={() => setViewMode('table')}
                sx={{
                  width: '32px',
                  height: '32px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  borderRadius: '999px',
                  cursor: 'pointer',
                  backgroundColor: viewMode === 'table'
                    ? Toggelbutton
                    : 'transparent',

                  transition: 'all 0.2s ease',

                }}
                title="Table view"
              >
                <Cardtoggle fillColor={toggleIconColor} />
              </Box>
            </Box>
          )}
        </div>

        <div className='filter-sec' sx={{ width: "100% !important" }}>

          <div className='filter' sx={{ width: "100%" }}>
            {/* Search Bar */}
            <Search className='search-btn' sx={{
              display: 'flex',
              alignItems: 'center',
              backgroundColor: mode === 'light' ? LIGHTCOLORS.BackgroundCard : DARKCOLORS.BackgroundCard,
              borderRadius: '60px',
              padding: '3px 20px',
              width: '40%',
              "@media (max-width: 425px)": {
                minWidth: '180px',
                padding: '3px 10px',
              },
              '&:hover': {
                backgroundColor: mode === 'light' ? LIGHTCOLORS.BackgroundCard : DARKCOLORS.BackgroundCard, // Same as default
                boxShadow: 'none', // Remove any shadow effects
              },
            }}>
              <SearchIconWrapper>
                <SearchIcon sx={{
                  fontSize: "20px",
                  "@media (max-width: 426px)": {
                    fontSize: "15px"
                  },
                  "@media (max-width: 350px)": {
                    marginRight: 'opx',
                    paddingRight: '0px'
                  }
                }} />
              </SearchIconWrapper>

              <StyledInputBase placeholder={t('vendingMachines.searchByLocation')} value={searchTerm} onChange={handleSearchChange} inputProps={{
                'aria-label': 'search',
                sx: {

                  '::placeholder': {
                    '@media (max-width: 426px)': {
                      fontSize: '13px',
                    },
                  },
                },
              }} />
            </Search>

            <Box sx={{ display: 'flex', gap: '5px', alignItems: 'center' }}>



              <div id="website-filter" className='vending-filter-sec  '>
                <Box sx={{ display: "flex", gap: 1 }} className='filbox'>
                  <Select
                    className='fil'
                    value={statusFilter}
                    onChange={handleStatusFilterChange}
                    displayEmpty
                    size="small"
                    IconComponent={(props) => (
                      <DropDownIcon color1={dropCircle} color2={dropIcon} {...props} sx={{
                        fontSize: "20px",
                        marginRight: "50px",
                        "@media (max-width: 426px)": {
                          fontSize: "15px",
                        }
                      }} />
                    )} // Use the custom DropDownIcon component
                    sx={{
                      borderRadius: "24px",
                      border: `0px solid ${borderColor1}`,
                      textAlign: "center",
                      paddingRight: "13px",
                      "& .MuiSelect-select": {
                        padding: "9px 20px 9px 20px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        "@media (max-width: 426px)": {
                          padding: "8px 15px 8px 15px",
                          fontSize: "10px",
                        },
                        "@media (max-width: 376px)": {
                          padding: "5px 10px 5px 10px",
                          fontSize: "10px",
                        },
                      },
                      "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                        border: `0.5px solid ${borderColor1}`,
                      },
                      '@media (max-width: 425px) and (min-width:300px)': {
                        padding: '2px 8px',
                        fontSize: '8px',
                      },
                    }}
                    MenuProps={{
                      PaperProps: {
                        sx: {
                          borderRadius: "16px",
                          border: `0px solid ${borderColor1}`,
                          boxShadow: "none",
                          backgroundColor: dropDownBg,
                          padding: "10px",
                          marginTop: "10px",
                        },
                      },
                    }}
                    renderValue={(selected) => {
                      if (selected === "") {
                        return (
                          <p className='sort-filter-text'>{t("membershipCards.filter")}</p>
                        );// Show "Sort" as placeholder when no value selected
                      }
                      return selected;
                    }}
                  >
                    <MenuItem className='menu-item-sec' value="">{t("membershipCards.all")}</MenuItem>
                    <MenuItem className='menu-item-sec' value="Active">{t("membershipCards.active")}</MenuItem>
                    <MenuItem className='menu-item-sec' value="Inactive">{t("membershipCards.inactive")}</MenuItem>
                    <MenuItem className='menu-item-sec' value="Normal">{t("vendingMachines.normal")}</MenuItem>
                    <MenuItem className='menu-item-sec' value="Abnormal">{t("vendingMachines.abnormal")}</MenuItem>
                  </Select>
                </Box>
              </div>
              <div className='add-machine1 '>
                {activeTab === 0 && user?.roles?.includes('ROLE_SUPER_ADMIN') &&
                  <IconButton id='vending-machine' className='add-machine ' onClick={() => navigate(ROUTES.ADD_MACHINE)}
                    sx={{
                      borderRadius: '40px', padding: '12px 26px 13px', backgroundColor: LIGHTCOLORS.Secondary500, color: "#000", mr: '7px', ml: '16px',
                      whiteSpace: 'nowrap',
                      "&:hover": {
                        backgroundColor: LIGHTCOLORS.Secondary500, // Same as default
                        color: "#000", // Same as default
                        boxShadow: "none", // Prevent shadow effects
                      },
                    }} >
                    {t("vendingMachines.add_machine")} <AddCircleOutline fontSize='small' sx={{
                      marginLeft: '10px', strokeWidth: '10', "@media (max-width: 426px)": {
                        fontSize: "15px"
                      }
                    }} />
                  </IconButton>
                }
              </div>
            </Box>

          </div>
          
          <Box id="mobile-filter" sx={{ mt: 1, width: '100%', p: '10px 5px' }} >
            <Box sx={{ width: '100%  !important', display: 'flex', justifyContent: 'flex-end !important', }}>
              <Box sx={{ display: "flex", gap: 1 }} className='filbox'>
                <Select
                  className='fil'
                  value={statusFilter}
                  onChange={handleStatusFilterChange}
                  displayEmpty
                  size="small"
                  IconComponent={(props) => (
                    <DropDownIcon color1={dropCircle} color2={dropIcon} {...props} sx={{
                      fontSize: "20px",
                      marginRight: "50px",
                      "@media (max-width: 426px)": {
                        fontSize: "15px",
                      }
                    }} />
                  )} // Use the custom DropDownIcon component
                  sx={{
                    borderRadius: "24px",
                    border: `0px solid ${borderColor1}`,
                    textAlign: "center",
                    paddingRight: "13px",
                    "& .MuiSelect-select": {
                      padding: "9px 20px 9px 20px",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      "@media (max-width: 426px)": {
                        padding: "8px 15px 8px 15px",
                        fontSize: "10px",
                      },
                      "@media (max-width: 376px)": {
                        padding: "5px 10px 5px 10px",
                        fontSize: "10px",
                      },
                    },
                    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                      border: `0.5px solid ${borderColor1}`,
                    },
                    '@media (max-width: 425px) and (min-width:300px)': {
                      padding: '2px 8px',
                      fontSize: '8px',
                    },
                  }}
                  MenuProps={{
                    PaperProps: {
                      sx: {
                        borderRadius: "16px",
                        border: `0px solid ${borderColor1}`,
                        boxShadow: "none",
                        backgroundColor: dropDownBg,
                        padding: "10px",
                        marginTop: "10px",
                      },
                    },
                  }}
                  renderValue={(selected) => {
                    if (selected === "") {
                      return (
                        <p className='sort-filter-text'>{t("membershipCards.filter")}</p>
                      );// Show "Sort" as placeholder when no value selected
                    }
                    return selected;
                  }}
                >
                  <MenuItem className='menu-item-sec' value="">{t("membershipCards.all")}</MenuItem>
                  <MenuItem className='menu-item-sec' value="Active">{t("membershipCards.active")}</MenuItem>
                  <MenuItem className='menu-item-sec' value="Inactive">{t("membershipCards.inactive")}</MenuItem>
                  <MenuItem className='menu-item-sec' value="Normal">{t("vendingMachines.normal")}</MenuItem>
                  <MenuItem className='menu-item-sec' value="Abnormal">{t("vendingMachines.abnormal")}</MenuItem>
                </Select>
              </Box>
            </Box>
          </Box>
        
        </div>

      </div>
      {activeTab === 0 && <InternalMachine searchTerm={searchTerm} filterTerm={statusFilter} viewMode={viewMode} />}
      {activeTab === 1 && <Franchisemachine searchTerm={searchTerm} filterTerm={statusFilter} franchiseId={franchiseId} />}
    </div >
  )
}

export default VendingMachines